module.exports = __webpack_public_path__ + "img/ctg-phone.5e8f1308.svg";